export default __webpack_public_path__ + "static/media/phone1.f8684b5a.png";